import { GET_GBP_LIST_URL, GET_WAREHOUSE_BEING_USED_LIST_URL, GET_LAYOUT_BY_WAREHOUSE_LIST_URL } from  '../const/APIUrl.js';
import { fetchAPI } from '../api/GenericFetch.js';

export const fetchWarehouseList = async(id) => {
    const response = await fetchAPI({url : GET_GBP_LIST_URL + '?locationid=' + id, body: null});
    return response;
}

export const fetchWarehouseBeingUsedList = async(id) => {
    const response = await fetchAPI({url : GET_WAREHOUSE_BEING_USED_LIST_URL + '?locationid=' + id, body: null});
    return response;
}

export const fetchLayoutByWarehouseList = async(locationId, warehouseId) => {
    const response = await fetchAPI({url : GET_LAYOUT_BY_WAREHOUSE_LIST_URL + '?locationid=' + locationId + '&warehouseId=' + warehouseId, body: null});
    return response;
}